import { memo as Memo, useMemo } from 'react'
import { useRouter } from 'next/router'

//* Components
import Text from 'components/common/Text'
import Container from 'components/common/Container'
import ButtonTag from 'components/common/Buttons/ButtonTag'
import Image from 'components/common/Image'

//* Style
import TopSectionStyle from './style'

const TopSection = Memo(({ tags }) => {
    const router = useRouter()

    const storeTags = useMemo(() => {
        return tags?.map(i => (
            <ButtonTag
                onClick={() => router.push(`/search?s=${i.name}`)}
                key={i.id}
                bordered
                purple
                content={i.name}
            />
        ))
    }, [tags])

    return tags ? (
        <TopSectionStyle>
            <Container className='flexBox alignMiddle'>
                <div className='left flexBoxColumn'>
                    <div className='title flexBoxWrap'>
                        <Text tag='span' className=' h1 NewYork' text='Create your' />
                        <Text tag='span' className='shape h1 NewYork' text='debate' />
                        <Text tag='span' className='h1 NewYork' text='or explore topics' />
                    </div>
                    <div className='tag-btns flexBoxWrap'>
                        {storeTags}
                    </div>
                </div>
                <Image src='/images/home/homeTopMessage.webp' priority={true} />
            </Container>
        </TopSectionStyle>
    ) : null
})

export default TopSection